module.exports = __webpack_public_path__ + "img/icon_cards.23f96a84.svg";